// extracted by mini-css-extract-plugin
export default {"container":"SplashScreen_container__+pB38","logoContent":"SplashScreen_logoContent__bNHln","logo":"SplashScreen_logo__beZT7"};